// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p, th, td{
  font-size: 18px;
}
td, th{
  height: fit-content;
  width: 300px;
  color: #bababa;
}
.footerText{
  color: #ffffff;
}
.backgroundGradient{
  background-image: radial-gradient(circle, white 55%, gold)
}

.banner{
  vertical-align: middle;
  background-color: #194f18;
  align-content: center;
  margin-top: 10px;
  margin-bottom: 30px;
}
.bannerText{
  font: 60px "Apple Chancery", cursive;
  color: wheat;
}
#subText{
  font: 25px "Apple Chancery", cursive;
  color: wheat;
}

menu{
  list-style-type: none;
  background-color: #333333;
  display: flex;
  justify-content: space-evenly;
  position: sticky;
  flex-wrap: wrap;
  top: 0;
  z-index: 1;
}
menu li a {
  display: block;
  color: white;
  padding: 14px 16px;
  text-decoration: none;
  outline-width: 0.1px;
  outline-color: #ffffff;
  outline-style: solid;
}
menu li:hover {
  background-color: #111111;
}

.grouping{
  display: flex;
  background-color: rgb(23, 80, 137);
  justify-content: center;
  justify-content: space-evenly;
}
#allFooter{
  display: flex;
  justify-content: center;
  justify-content: space-evenly;
  background-color: #194f18;
  margin-top: 30px;
}

.dividers{
  display: flex;
  justify-content: space-around;
}

/* for social media buttons */
.fa {
  padding: 20px;
  font-size: 30px;
  width: 70px;
  text-align: center;
  text-decoration: none;
  border-radius: 50%;
}

/* Add a hover effect if you want */
.fa:hover {
  opacity: 0.7;
}

/* Set a specific color for each brand */

/* Facebook */
.fa-facebook {
  background: #3B5998;
  color: white;
}
.fa-envelope-o {
  background: #dd4b39;
  color: white;
}

/* text stylings */
#important{
    font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Main.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,UAAU;AACZ;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,YAAY;AACd;;AAEA,wCAAwC;;AAExC,aAAa;AACb;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,kBAAkB;AAClB;IACI,eAAe;AACnB","sourcesContent":["p, th, td{\n  font-size: 18px;\n}\ntd, th{\n  height: fit-content;\n  width: 300px;\n  color: #bababa;\n}\n.footerText{\n  color: #ffffff;\n}\n.backgroundGradient{\n  background-image: radial-gradient(circle, white 55%, gold)\n}\n\n.banner{\n  vertical-align: middle;\n  background-color: #194f18;\n  align-content: center;\n  margin-top: 10px;\n  margin-bottom: 30px;\n}\n.bannerText{\n  font: 60px \"Apple Chancery\", cursive;\n  color: wheat;\n}\n#subText{\n  font: 25px \"Apple Chancery\", cursive;\n  color: wheat;\n}\n\nmenu{\n  list-style-type: none;\n  background-color: #333333;\n  display: flex;\n  justify-content: space-evenly;\n  position: sticky;\n  flex-wrap: wrap;\n  top: 0;\n  z-index: 1;\n}\nmenu li a {\n  display: block;\n  color: white;\n  padding: 14px 16px;\n  text-decoration: none;\n  outline-width: 0.1px;\n  outline-color: #ffffff;\n  outline-style: solid;\n}\nmenu li:hover {\n  background-color: #111111;\n}\n\n.grouping{\n  display: flex;\n  background-color: rgb(23, 80, 137);\n  justify-content: center;\n  justify-content: space-evenly;\n}\n#allFooter{\n  display: flex;\n  justify-content: center;\n  justify-content: space-evenly;\n  background-color: #194f18;\n  margin-top: 30px;\n}\n\n.dividers{\n  display: flex;\n  justify-content: space-around;\n}\n\n/* for social media buttons */\n.fa {\n  padding: 20px;\n  font-size: 30px;\n  width: 70px;\n  text-align: center;\n  text-decoration: none;\n  border-radius: 50%;\n}\n\n/* Add a hover effect if you want */\n.fa:hover {\n  opacity: 0.7;\n}\n\n/* Set a specific color for each brand */\n\n/* Facebook */\n.fa-facebook {\n  background: #3B5998;\n  color: white;\n}\n.fa-envelope-o {\n  background: #dd4b39;\n  color: white;\n}\n\n/* text stylings */\n#important{\n    font-size: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
